export default __webpack_public_path__ + "static/media/twitter.4fc5eb86.svg";